<template src="./TwoFactorForm.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import FieldData from "@/services/fieldData";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    props: { loading: { type: Boolean } },
    emits: ["submit"],
    methods: {
        async submit(): Promise<void> {
            const form = this.$refs.form as VForm;
            const validationResult = await form.validate();
            if (validationResult.valid)
                this.$emit("submit", this.twoFactorPassword);
        }
    },
    data() {
        return {
            twoFactorPassword: "",
            secuityCodeData: new FieldData("Security code", {
                required: true,
                regex: {
                    pattern: /^(\d{6}|\w{5}-\w{5})$/,
                    message:
                        "Security code has to be 6 digits or in the format 'XXXXX-XXXXX'."
                }
            })
        };
    }
});
</script>

<style src="./TwoFactorForm.scss" lang="scss" scoped></style>
